import Api, { axiosInstance } from '../Api';

export default class PreCheckout {
  endPoint = 'PreCheckout';

  async preCheckoutCheck() {
    try {
      // always call without userId & key, in order to be consistent when user logs in after this call
      const r = await axiosInstance.get(`/${this.endPoint}/Check`, {});
      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }
}
